import { render } from "./review.vue?vue&type=template&id=69c5ba7d&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"

import "./review.vue?vue&type=style&index=0&id=69c5ba7d&scoped=true&lang=css"

import exportComponent from "D:\\Code\\mt\\hql\\bm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69c5ba7d"]])

export default __exports__